import './message.css';
import React from 'react';
import Notification from 'rc-notification';

let notification = null;
Notification.newInstance({
    style: {
        top:  '40%',
        left: '50%',
        // transform:'translateX(-50%)',
        // zIndex: 1000001
        zIndex: 1000000001
    }
}, n => {
    notification = n;
});

// eslint-disable-next-line
function show (text) {
    notification.notice({
        duration: 2,
        content: <span>{text}</span>
    });
}

const Message = {
    show
};
window.showMessage = show;
export default Message;
